import { pageList, type PageItem } from '@/lib/page-list';

export function ListRange({ start, end, total }: { start: number; end: number; total: number }) {
  return (
    <span className="lms-course-forum-card__meta">
      Mostrando <strong>{start}</strong> a <strong>{end}</strong> de <strong>{total}</strong> resultados
    </span>
  );
}

export function ListPager({
  page,
  totalPages,
  onPageChange,
}: {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}) {
  const items: PageItem[] = pageList(page, totalPages);
  return (
    <div className="lms-course-forum-card__pager">
      <button
        type="button"
        className="lms-course-forum-card__pager-btn"
        aria-label="Página anterior"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        <span className="material-symbols-outlined" aria-hidden="true">
          chevron_left
        </span>
      </button>
      {items.map((item, index) =>
        item === '…' ? (
          <span key={`gap-${index}`} className="lms-course-forum-card__pager-gap" aria-hidden="true">
            …
          </span>
        ) : item === page ? (
          <span key={item} className="lms-course-forum-card__pager-current" aria-current="page">
            {item}
          </span>
        ) : (
          <button
            key={item}
            type="button"
            className="lms-course-forum-card__pager-btn lms-course-forum-card__pager-num"
            aria-label={`Página ${item}`}
            onClick={() => onPageChange(item)}
          >
            {item}
          </button>
        ),
      )}
      <button
        type="button"
        className="lms-course-forum-card__pager-btn"
        aria-label="Página siguiente"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        <span className="material-symbols-outlined" aria-hidden="true">
          chevron_right
        </span>
      </button>
    </div>
  );
}

export function ListFooter({
  page,
  totalPages,
  total,
  start,
  end,
  onPageChange,
}: {
  page: number;
  totalPages: number;
  total: number;
  start: number;
  end: number;
  onPageChange: (page: number) => void;
}) {
  if (total <= 0) return null;
  return (
    <div className="lms-course-forum-card__footer">
      <ListRange start={start} end={end} total={total} />
      <ListPager page={page} totalPages={totalPages} onPageChange={onPageChange} />
    </div>
  );
}
